import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron--thick-sharp-right",
  "use": "icon-chevron--thick-sharp-right-usage",
  "viewBox": "0 0 6 8",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6 8\" id=\"icon-chevron--thick-sharp-right\"><path d=\"m1.25 7 3-3-3-3\" stroke=\"#fff\" stroke-width=\"1.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol